import React from 'react';
import { useTranslation } from 'react-i18next';
import { ConfirmModal } from '../../../components/ConfirmModal/ConfirmModal';
import { TranslationKey } from '../../../i18n/translationKeys';
import type { SyncStartDateResyncPromptProps } from './types';

/**
 * Asks whether to run a full sync right after the sync start date changed. Only a full sync re-reads
 * the source from the new date — an incremental one is bounded by the last sync and would leave the
 * data reflecting the previous window. Declining keeps the saved date for the next sync.
 */
export const SyncStartDateResyncPrompt: React.FC<SyncStartDateResyncPromptProps> = ({
    startDate,
    onConfirm,
    onCancel,
}) => {
    const { t } = useTranslation();

    return (
        <ConfirmModal
            heading={t(TranslationKey.SyncStartDate.ResyncTitle)}
            body={t(TranslationKey.SyncStartDate.ResyncBody, { date: startDate })}
            confirmLabel={t(TranslationKey.SyncStartDate.ResyncConfirm)}
            cancelLabel={t(TranslationKey.SyncStartDate.ResyncCancel)}
            onConfirm={onConfirm}
            onCancel={onCancel}
            modalTestId="sync-start-date-resync-modal"
            confirmBtnTestId="sync-start-date-resync-confirm-btn"
            cancelBtnTestId="sync-start-date-resync-cancel-btn"
        />
    );
};
